<div class="client-info-wrapper">
  <div class="client-info">
    <h1 class="client-info__title">Client Info</h1>
    @if (!editingClientName) {
    <div class="client-info__workspace-section">
      <h2>Client Workspace Name</h2>
      <p>
        {{ current_company.name }}
        <button
          class="btn btn-link"
          (click)="editingClientName = !editingClientName"
        >
          <!-- editingClientName = true on click -->
          <i class="feather edit-3"></i>
        </button>
      </p>
    </div>
    } @if (editingClientName) {
    <div class="client-info__workspace-section">
      <h2>Client</h2>
      <input
        class="form-control"
        type="text"
        placeholder="Client Name"
        #nameInput
        [(ngModel)]="current_company.name"
      />
      <button
        class="btn btn-success btn-block"
        (click)="editingClientName = !editingClientName; updateCompanyName()"
      >
        <i class="feather check"></i> Save
      </button>
    </div>
    }
    <div class="client-info__workspace-tagging">
      <div class="form-group">
        <label>Tags</label>
        <div class="tag-list">
          @for (tag of tags; track tag) {
          <ch-tag
            [name]="tag.name"
            [color]="tag.color"
            (remove)="removeTagFromWorkspace(tag)"
            [canRemove]="true"
          >
          </ch-tag>
          }
          <ch-tag-add
            [workspace]="current_company?.company_conversation"
            [existingTags]="tags"
            (tagClick)="addTag($event)"
          ></ch-tag-add>
        </div>
      </div>
    </div>
    <div class="client-info__client-custom-data">
      <div class="title-wrapper">
        <h2>Client Details</h2>
        <a class="link" (click)="openDrawer()">Edit values</a>
      </div>
      <div>
        @for (data_field of current_company.data_field_values; track data_field)
        {
        <div class="custom-data-field">
          <p>{{ data_field.field.name }}</p>
          @if (data_field.field.type == 'date') {
          <span>{{ data_field.value | date }}</span>
          } @else {
          <span>{{ data_field.value }}</span>
          }
        </div>
        }
      </div>
    </div>
    <div class="button-container">
      <button
        id="btn"
        class="btn btn-default btn-archive"
        (click)="archiveCompany(archiveConfirmation)"
      >
        @if (current_company.archived) {
        <i class="tio-unarchive"></i>
        } @if (!current_company.archived) {
        <i class="tio-archive"></i>
        }
        <span style="margin-top: 3px">
          @if (!current_company.archived) {
          <span>Archive Workspace</span>
          } @if (current_company.archived) {
          <span>Restore Workspace</span>
          }
        </span>
      </button>
    </div>
  </div>
</div>

<ng-template #archiveConfirmation>
  <div class="modal-header text-center">
    <h4>Are you sure?</h4>
    @if (!current_company.archived) {
    <p>
      Are you sure you want to archive this workspace? When you archive: <br />
      (1) Any open internal jobs and client tasks will be marked as
      Completed/Closed, and <br />
      (2) All Client Users will lose access to Client Hub.
    </p>
    } @if (current_company.archived) {
    <p>Are you sure you want to restore this company?</p>
    }
    <div class="row">
      <div class="col-xs-6">
        <button
          type="button"
          class="btn btn-primary pull-left btn-block"
          (click)="confirmArchivation(current_company.id)"
        >
          Yes
        </button>
      </div>
      <div class="col-xs-6">
        <button
          type="button"
          class="btn btn-default pull-right btn-block"
          (click)="declineArchivation()"
        >
          No
        </button>
      </div>
    </div>
  </div>
</ng-template>

<app-drawer
  [isForClientDetails]="true"
  [clientDataFieldValues]="current_company.data_field_values"
  [ngClass]="{ open: drawerOpen }"
  (onHide)="changeHide($event)"
></app-drawer>
